var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41675 9.99992C2.41675 9.19321 2.9352 7.70463 4.18615 6.40557C5.40729 5.13747 7.29896 4.08325 10.0001 4.08325C12.7012 4.08325 14.5929 5.13747 15.814 6.40557C17.065 7.70463 17.5834 9.19321 17.5834 9.99992C17.5834 10.8066 17.065 12.2952 15.814 13.5943C14.5929 14.8624 12.7012 15.9166 10.0001 15.9166C7.29896 15.9166 5.40729 14.8624 4.18615 13.5943C2.9352 12.2952 2.41675 10.8066 2.41675 9.99992ZM10.0001 2.58325C6.86787 2.58325 4.59288 3.8207 3.10567 5.3651C1.64829 6.87854 0.916748 8.7233 0.916748 9.99992C0.916748 11.2765 1.64829 13.1213 3.10567 14.6347C4.59288 16.1791 6.86787 17.4166 10.0001 17.4166C13.1323 17.4166 15.4073 16.1791 16.8945 14.6347C18.3519 13.1213 19.0834 11.2765 19.0834 9.99992C19.0834 8.7233 18.3519 6.87854 16.8945 5.3651C15.4073 3.8207 13.1323 2.58325 10.0001 2.58325ZM8.25001 9.99992C8.25001 9.03342 9.03351 8.24992 10 8.24992C10.9665 8.24992 11.75 9.03342 11.75 9.99992C11.75 10.9664 10.9665 11.7499 10 11.7499C9.03351 11.7499 8.25001 10.9664 8.25001 9.99992ZM10 6.74992C8.20508 6.74992 6.75001 8.20499 6.75001 9.99992C6.75001 11.7948 8.20508 13.2499 10 13.2499C11.7949 13.2499 13.25 11.7948 13.25 9.99992C13.25 8.20499 11.7949 6.74992 10 6.74992Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9bcd321ac57a401596feb112e94c878c.svg";
export { ForwardRef as ReactComponent };